<template>
  <fragment>
    <template v-if="!isAdmin()">
      <!-- <v-card persistent fullscreen flat> -->
      <!-- <v-tabs
        v-model="tab"
        class="rounded-lg"
        background-color="base"
        color="dark"
        grow
      >
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab active-class="tertiary white--text rounded-lg">
          <v-icon>mdi-list-status</v-icon>
          <span class="pl-2">Resumo</span>
        </v-tab>
        <v-tab active-class="tertiary white--text rounded-lg">
          <v-icon>mdi-view-dashboard-variant-outline</v-icon>
          <span class="pl-2">Dashboard</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="pt-4">
        <v-tab-item> -->
      <!-- <Dashboard /> -->
      <!-- <v-row>
          <v-col>
            <v-divider></v-divider>
          </v-col>
        </v-row> -->
      <Resume />
      <!-- </v-tab-item>
        <v-tab-item> -->
      <!-- </v-tab-item> -->
      <!-- </v-tabs-items> -->
      <!-- </v-card> -->
    </template>
    <Dashboard v-else />
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import Dashboard from "@/views/Dashboard.vue";
import Resume from "@/views/Resume.vue";

export default {
  name: "Home",
  metaInfo: {
    title: "ElevenTickets | Home",
    meta: [
      {
        property: "og:title",
        content: "ElevenTickets | Home",
      },
    ],
  },
  components: {
    Dashboard,
    Resume,
  },
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    ...mapGetters(["dashEvent", "isOpenModal"]),
  },
  methods: {
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return true;
      return false;
    },
  },
};
</script>
